import { NavDropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { logout as logoutUser } from "../../../../api/user-service";
import { question, toast } from "../../../../helpers/functions/swal";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { logOut } from "../../../../store/slices/auth-slice";
import LoadingPage from "../../../../pages/common/LoadingPage";

const MenuDropdown = () => {
  const { user } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    question("Logout", "Sind Sie sicher, dass Sie sich abmelden möchten?").then(
      async (result) => {
        if (result.isConfirmed) {
          try {
            await logoutUser();
            dispatch(logOut());
            navigate("/");
          } catch (error) {
            toast(
              "Die Abmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
              "error"
            );
          }
        }
      }
    );
  };

  if (!user) {
    return <LoadingPage />;
  }

  return (
    <NavDropdown title={user.name.substring(0, 10)} className="userName">
      <NavDropdown.Item as={Link} to={`/profile/${user.id}`}>
        Profil
      </NavDropdown.Item>
      <NavDropdown.Item as={Link} to="/projects-user">
        Meine Projekte
      </NavDropdown.Item>

      {user.is_superuser && (
        <>
          <NavDropdown.Divider />

          <NavDropdown.Item as={Link} to="/admin-projects">
            Dashboard
          </NavDropdown.Item>

          <NavDropdown.Divider />
        </>
      )}

      <NavDropdown.Item onClick={handleLogout}>Abmelden</NavDropdown.Item>
    </NavDropdown>
  );
};

export default MenuDropdown;
